import styled from 'styled-components'

export const Container = styled.div`
  display: block;
  height: 100vh;
  position: relative;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .wave{
    position: absolute;
    bottom: -75px;
    left: 0;
    right: 0;
    z-index: -1;
  }

  img.logo{
    margin-bottom: 6.2rem;
  }
`
